import script from "./form-item-wrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./form-item-wrapper.vue?vue&type=script&setup=true&lang=js"

import "./form-item-wrapper.vue?vue&type=style&index=0&id=a950b9c6&lang=scss&scoped=true"

import exportComponent from "D:\\code\\form_designer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a950b9c6"]])

export default __exports__